import React from "react";
import {
  Box,
  Paper,
  Typography,
  Divider,
  Stepper,
  Step,
  StepLabel,
  TextField,
  Button,
  Alert,
  Stack,
  Grid, // Grid import edildi
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import Cards from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import PaymentIcon from "@mui/icons-material/Payment";
import { v4 as uuidv4 } from "uuid";
import useCustomerStore from "../stores/useCustomerStore";
import usePaymentStore from "../stores/usePaymentStore";
import useAuthStore from "../stores/useAuthStore";

interface PaymentFormInputs {
  cardHolderName: string;
  cardNumber: string;
  expiryDate: string;
  cvv: string;
  saveForFuture: boolean;
  installment: string;
  currency: string;
}

function PaymentPage() {
  const { selectedCustomer } = useCustomerStore();
  const { sendPayment, isLoading, error, success } = usePaymentStore();
  const [clientIp, setClientIp] = React.useState<string>("");
  const { selectedInstallment,amount } = useAuthStore();
  const user = useAuthStore((state) => state.user);
  const adminInfo = useAuthStore((state) => state.adminInfo);
  const customerId = useAuthStore((state) => state.customerId);

 

  

  const [cardData, setCardData] = React.useState({
    cardNumber: "",
    cardHolderName: "",
    expiryDate: "",
    cvv: "",
  });
  const [cardFocus, setCardFocus] = React.useState<
    "number" | "name" | "expiry" | "cvc" | undefined
  >(undefined);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<PaymentFormInputs>({
    defaultValues: {
      cardHolderName: "",
      cardNumber: "",
      expiryDate: "",
      cvv: "",
      saveForFuture: false,
      installment: "1",
      currency: "TRY",
    },
  });

  React.useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) => setClientIp(data.ip))
      .catch(() => setClientIp("0.0.0.0")); // fallback IP
  }, []);

  const onSubmit = async (data: PaymentFormInputs) => {
    const [month, year] = data.expiryDate.split("/");
    const paymentData = {
      MerchantPaymentId: uuidv4(),
      CardOwner: data.cardHolderName,
      Pan: data.cardNumber,
      ExpiryMonth: month,
      ExpiryYear: year,
      Cvv: data.cvv,
      Amount: amount,
      Currency: data.currency,
      InstallmentCount: selectedInstallment ? String(selectedInstallment) : "1",
      Customer: selectedCustomer?.CariKod || user?.CariKod || "",
      CustomerName: selectedCustomer?.CariIsim || user?.CariIsim|| "",
      CustomerIp: clientIp || "1.1.1.1",
      CreateUser: user?.CariIsim||adminInfo?.customerName || "",
      CustomerId:customerId ||  "",
    };

    const response = await sendPayment(paymentData);

    if (response && typeof response === "string") {
      document.open();
      document.write(response);
      document.close();
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "80vh",
        // background: "linear-gradient(120deg, #f0f4ff 0%, #e1ecf7 100%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        py: 2,
        overflow: "hidden",
      }}
    >
      <Box sx={{ width: { xs: "90%", md: "60%" }, mb: 3 }}>
        <Stepper activeStep={1} alternativeLabel>
          <Step>
            <StepLabel>Taksit Seçimi</StepLabel>
          </Step>
          <Step>
            <StepLabel>Ödeme Detayları</StepLabel>
          </Step>
          <Step>
            <StepLabel>Tamamla</StepLabel>
          </Step>
        </Stepper>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          width: { xs: "90%", md: "60%" },
          gap: 2,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            flex: 1.2,
            p: { xs: 2, md: 3 },
            display: "flex",
            flexDirection: "column",
            borderRadius: 2,
            gap: 2,
          }}
        >
          <Typography variant="h6" fontWeight="bold" mb={1}>
            Ödeme Detayları
          </Typography>
          <Divider />

          <Cards
            number={cardData.cardNumber}
            name={cardData.cardHolderName}
            expiry={cardData.expiryDate.replace("/", "")}
            cvc={cardData.cvv}
            focused={cardFocus}
          />

          <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            noValidate
            sx={{ display: "flex", flexDirection: "column", gap: 2 }}
          >
            {/* Kart Sahibi Adı ve Kart Numarası yan yana */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Kart Sahibi Adı"
                  variant="outlined"
                  fullWidth
                  {...register("cardHolderName", {
                    required: "Kart sahibi adı gereklidir",
                    minLength: {
                      value: 3,
                      message: "En az 3 karakter giriniz",
                    },
                  })}
                  error={!!errors.cardHolderName}
                  helperText={errors.cardHolderName?.message}
                  onChange={(e) =>
                    setCardData((prev) => ({
                      ...prev,
                      cardHolderName: e.target.value,
                    }))
                  }
                  onFocus={() => setCardFocus("name")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Controller
                  name="cardNumber"
                  control={control}
                  rules={{
                    required: "Kart numarası gereklidir",
                    pattern: {
                      value: /^\d{16}$/,
                      message: "Kart numarası 16 haneli olmalıdır",
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      label="Kart Numarası"
                      variant="outlined"
                      fullWidth
                      placeholder="XXXX XXXX XXXX XXXX"
                      value={cardData.cardNumber
                        .replace(/\s?/g, "")
                        .replace(/(\d{4})/g, "$1 ")
                        .trim()}
                      inputProps={{ maxLength: 19 }}
                      error={!!errors.cardNumber}
                      helperText={errors.cardNumber?.message}
                      onChange={(e) => {
                        const rawValue = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 16);
                        setCardData((prev) => ({
                          ...prev,
                          cardNumber: rawValue,
                        }));
                        field.onChange(rawValue);
                      }}
                      onFocus={() => setCardFocus("number")}
                    />
                  )}
                />
              </Grid>
            </Grid>

            {/* Son Kullanma Tarihi, CVV ve Taksit Sayısı yan yana */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Son Kullanma Tarihi (AA/YY)"
                  variant="outlined"
                  fullWidth
                  placeholder="MM/YY"
                  value={cardData.expiryDate}
                  inputProps={{ maxLength: 5 }}
                  {...register("expiryDate", {
                    required: "Son kullanma tarihi gereklidir",
                    pattern: {
                      value: /^(0[1-9]|1[0-2])\/\d{2}$/,
                      message: "Geçerli bir tarih formatı giriniz (MM/YY)",
                    },
                  })}
                  error={!!errors.expiryDate}
                  helperText={errors.expiryDate?.message}
                  onChange={(e) => {
                    const input = e.target.value.replace(/\D/g, "").slice(0, 4);
                    const formatted =
                      input.length >= 3
                        ? `${input.slice(0, 2)}/${input.slice(2)}`
                        : input;
                    setCardData((prev) => ({ ...prev, expiryDate: formatted }));
                  }}
                  onFocus={() => setCardFocus("expiry")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="CVV"
                  variant="outlined"
                  fullWidth
                  placeholder="XXX"
                  inputProps={{ maxLength: 3 }}
                  {...register("cvv", {
                    required: "CVV kodu gereklidir",
                    pattern: {
                      value: /^\d{3}$/,
                      message: "CVV kodu 3 haneli olmalıdır",
                    },
                  })}
                  error={!!errors.cvv}
                  helperText={errors.cvv?.message}
                  onChange={(e) =>
                    setCardData((prev) => ({ ...prev, cvv: e.target.value }))
                  }
                  onFocus={() => setCardFocus("cvc")}
                />
              </Grid>
            </Grid>

            {/* Para Birimi ve Bilgileri Kaydet seçeneği yan yana */}
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Para Birimi"
                  variant="outlined"
                  fullWidth
                  defaultValue="TRY"
                  {...register("currency")}
                />
              </Grid>
              
            </Grid>

            {Object.keys(errors).length > 0 && (
              <Alert severity="error">
                Lütfen form alanlarını kontrol ediniz.
              </Alert>
            )}

            {error && <Alert severity="error">{error}</Alert>}
            {success && (
              <Alert severity="success">Ödeme başarıyla tamamlandı.</Alert>
            )}

            <Stack direction="row" justifyContent="center" mt={2}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                startIcon={<PaymentIcon />}
                disabled={isLoading}
              >
                {isLoading ? "Gönderiliyor..." : "Ödeme Yap"}
              </Button>
            </Stack>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}

export default PaymentPage;
